import { render, staticRenderFns } from "./VHelpIcon.vue?vue&type=template&id=355da60e&"
import script from "./VHelpIcon.vue?vue&type=script&lang=ts&"
export * from "./VHelpIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VHelpIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports